import { useState, useEffect } from "react";
import { ReactTransliterate } from "react-transliterate";
import editIcon from "../../assests/icons/edit.jpg";
import deleteIcon from "../../assests/icons/delete.jpg";
import publishIcon from "../../assests/icons/publish.png";
import { isAdmin, isApprover, isPublisher } from "../utils/auth.js";
import parse from "html-react-parser";
import { showHideLoader, processImage } from "../utils/helper.js";
import {
  getVishwasthaMandalTypes,
  getYears,
} from "../../network/lib/masterData.js";
import {
  vishwasthaMandalObject,
  save,
  update,
  deleteLive,
  deletePreview,
  publish,
  getPreviewByVishwasthaMandalType,
  getLiveByVishwasthaMandalType,
} from "../../network/lib/vishwasthaMandal.js";
import { convertToNumerals } from "../utils/helper.js";

function VishwasthaMandal({ user }) {
  const [vishwasthaMandalTypes, setVishwasthaMandalTypes] = useState();
  const [years, setYears] = useState();
  const [vishwasthaMandalType, setVishwasthaMandalType] = useState("1");
  const [previewVishwasthaMandalType, setPreviewVishwasthaMandalType] =
    useState("1");
  const [liveVishwasthaMandalType, setLiveVishwasthaMandalType] = useState("1");
  const [name, setName] = useState("");
  const [fromPeriod, setFromPeriod] = useState("1");
  const [toPeriod, setToPeriod] = useState("1");
  const [image, setImage] = useState("");
  const [previewData, setPreviewData] = useState();
  const [liveData, setLiveData] = useState();

  const [id, setId] = useState(0);

  const admin = isAdmin(user.roleId);
  const approver = isApprover(user.roleId);
  const publisher = isPublisher(user.roleId);

  useEffect(() => {
    !vishwasthaMandalTypes && populateVishwasthaMandalTypes();
    !years && populateYears();
  }, []);

  const populateVishwasthaMandalTypes = () => {
    getVishwasthaMandalTypes().then((res) => {
      if (res.status == 200) {
        setVishwasthaMandalTypes(res.data);
        setPreviewVishwasthaMandalType(res.data);
        setLiveVishwasthaMandalType(res.data);
      }
    });
  };

  const populateYears = () => {
    getYears().then((res) => {
      if (res.status == 200) {
        setYears(res.data);
      }
    });
  };

  const setToDefault = () => {
    setVishwasthaMandalType("1");
    setName("");
    setFromPeriod("1");
    setToPeriod("1");
    setImage("");
    setId(0);
    setPreviewData(undefined);
    setLiveData(undefined);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetMessage();
    setToDefault();
  };

  const resetMessage = () => {
    let message = document.getElementById("message");
    message.innerHTML = "";
    message.classList.replace("success", "alert");
    return message;
  };

  const handleEdit = (e) => {
    e.preventDefault();
    resetMessage();

    let dataParams = e.target.getAttribute("data-params");
    if (dataParams) {
      let params = JSON.parse(dataParams);
      setId(params.id);
      setVishwasthaMandalType(params.vishwasthaMandalTypeId);
      setName(params.name);
      setFromPeriod(params.fromPeriodId);
      setToPeriod(params.toPeriodId);
      setImage(params.image);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let message = resetMessage();

    setLiveData(undefined);
    setPreviewData(undefined);

    let fromPeriodText = years.find((x) => x.id == parseInt(fromPeriod)).name;
    let toPeriodText = years.find((x) => x.id == parseInt(toPeriod)).name;

    if (name == "") {
      message.innerHTML = "Please provide Name";
    } else if (
      convertToNumerals(fromPeriodText) > convertToNumerals(toPeriodText)
    ) {
      message.innerHTML =
        "Please select valid 'To Period'. 'From Period' cannot be greater than 'To Period'";
    } else {
      showHideLoader(true);

      vishwasthaMandalObject.id = id;
      vishwasthaMandalObject.vishwasthaMandalTypeId = vishwasthaMandalType;
      vishwasthaMandalObject.name = name;
      vishwasthaMandalObject.fromPeriodId = fromPeriod;
      vishwasthaMandalObject.toPeriodId = toPeriod;
      vishwasthaMandalObject.image = image;
      vishwasthaMandalObject.userName = user.userName;

      if (id == 0) {
        save(vishwasthaMandalObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data saved successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      } else {
        update(vishwasthaMandalObject).then((res) => {
          if (res.status == 200 && res.data) {
            message.classList.replace("alert", "success");
            message.innerHTML = "Data updated successfully!!!";
            setToDefault();
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
          showHideLoader();
        });
      }
    }
  };

  const fetchPreviewData = (vishwasthaMandalType) => {
    showHideLoader(true);

    getPreviewByVishwasthaMandalType(vishwasthaMandalType)
      .then((resp) => {
        if (resp.status == 200) {
          setPreviewData(resp.data);
          setLiveData(undefined);
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handlePreviewData = (e) => {
    e.preventDefault();
    resetMessage();
    setPreviewVishwasthaMandalType("1");
    fetchPreviewData("1");
  };

  const fetchLiveData = (vishwasthaMandalType) => {
    showHideLoader(true);

    getLiveByVishwasthaMandalType(vishwasthaMandalType)
      .then((resp) => {
        if (resp.status == 200) {
          setLiveData(resp.data);
          setPreviewData(undefined);
          showHideLoader();
        }
      })
      .catch((e) => console.log(e));
  };

  const handleLiveData = (e) => {
    e.preventDefault();
    resetMessage();
    setLiveVishwasthaMandalType("1");
    fetchLiveData("1");
  };

  const handleDeletePreview = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (window.confirm("Do you really want to delete the item from Preview?")) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        vishwasthaMandalObject.id = parseInt(params);
        vishwasthaMandalObject.userName = user.userName;

        deletePreview(vishwasthaMandalObject).then((res) => {
          if (res.status == 200 && res.data) {
            fetchPreviewData(previewVishwasthaMandalType);
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handleDeleteLive = (e) => {
    e.preventDefault();
    let message = resetMessage();
    if (
      window.confirm(
        "Do you really want to delete the item from Live? This will be moved to Preview."
      )
    ) {
      let params = e.target.getAttribute("data-params");
      if (params) {
        vishwasthaMandalObject.id = parseInt(params);
        vishwasthaMandalObject.userName = user.userName;

        deleteLive(vishwasthaMandalObject).then((res) => {
          if (res.status == 200 && res.data) {
            fetchLiveData(liveVishwasthaMandalType);
          } else {
            message.innerHTML = "Some error occurred. Please try again";
          }
        });
      }
    }
  };

  const handlePublish = (e) => {
    e.preventDefault();
    let message = resetMessage();

    let params = e.target.getAttribute("data-params");
    if (params) {
      vishwasthaMandalObject.id = parseInt(params);
      vishwasthaMandalObject.userName = user.userName;

      publish(vishwasthaMandalObject).then((res) => {
        if (res.status == 200 && res.data) {
          fetchPreviewData(previewVishwasthaMandalType);
          setToDefault();
        } else {
          message.innerHTML = "Some error occurred. Please try again";
        }
      });
    }
  };

  const handleImage = (e) => {
    processImage(e.target.files[0], resetMessage(), setImage);
  };

  const contents = (
    <>
      <table>
        <tbody>
          <tr>
            <th align="center" colSpan="4">
              Vishwastha Mandal
            </th>
          </tr>
          <tr>
            <td align="right">
              <span>Vishwastha Mandal Type</span>
            </td>
            <td colSpan={3}>
              {vishwasthaMandalTypes && (
                <select
                  onChange={(e) => setVishwasthaMandalType(e.target.value)}
                  value={vishwasthaMandalType}
                  style={{ width: "274px" }}
                >
                  {vishwasthaMandalTypes.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Name</span>
            </td>
            <td colSpan={3}>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="1" cols="94" />
                )}
                value={name}
                onChangeText={(text) => {
                  setName(text);
                }}
                lang="mr"
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>From Period</span>
            </td>
            <td>
              {years && (
                <select
                  onChange={(e) => setFromPeriod(e.target.value)}
                  value={fromPeriod}
                  style={{ width: "274px" }}
                >
                  {years.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
            <td align="right">
              <span>To Period</span>
            </td>
            <td>
              {years && (
                <select
                  onChange={(e) => setToPeriod(e.target.value)}
                  value={toPeriod}
                  style={{ width: "274px" }}
                >
                  {years.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Photo</span>
            </td>
            <td>
              <label
                htmlFor="file-upload"
                className="custom-file-upload"
                style={{ width: "259px", textAlign: "center" }}
              >
                Browse
              </label>
              <input
                type="file"
                id="file-upload"
                accept="image/*"
                onChange={(e) => handleImage(e)}
              />
            </td>
            <td colSpan={2}>
              {image && (
                <img
                  src={image}
                  style={{ width: "150px", height: "150px", float: "left" }}
                />
              )}
            </td>
          </tr>
          <tr>
            <td colSpan={2}></td>
            <td
              colSpan={2}
              style={{ textAlign: "right", paddingRight: "60px" }}
            >
              <input
                className="btn"
                type="submit"
                value="Cancel"
                id="btnCancel"
                onClick={handleCancel}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="Submit"
                id="btnSubmit"
                onClick={handleSubmit}
              />
            </td>
          </tr>
          <tr>
            <td colSpan="4" style={{ textAlign: "center" }}>
              <div
                id="message"
                className="alert"
                style={{ textAlign: "center" }}
              ></div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td colSpan={2}>
              <input
                className="btn"
                type="submit"
                style={{ float: "left" }}
                value="View Preview"
                id="btnPreviewData"
                onClick={handlePreviewData}
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                value="View Live"
                id="btnLiveData"
                onClick={handleLiveData}
              />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      {previewData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 8 : approver ? 7 : 6}>
                Preview
              </th>
            </tr>
            <tr align="center">
              <td colSpan={admin ? 8 : approver ? 7 : 6}>
                <span>Vishwastha Mandal Type: </span>
                {vishwasthaMandalTypes && (
                  <select
                    onChange={(e) => {
                      setPreviewVishwasthaMandalType(e.target.value);
                      fetchPreviewData(e.target.value);
                    }}
                    value={previewVishwasthaMandalType}
                  >
                    {vishwasthaMandalTypes.map((x, i) => (
                      <option key={i} value={x.id}>
                        {x.name}
                      </option>
                    ))}
                  </select>
                )}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr align="center">
              {publisher && (
                <td style={{ textAlign: "center" }}>
                  <u>Publish</u>
                </td>
              )}
              <td>
                <u>Name</u>
              </td>
              <td>
                <u>Vishwastha Mandal Type</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>From Period</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>To Period</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Image</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Edit</u>
              </td>
              {admin && (
                <td style={{ textAlign: "center" }}>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {previewData.length > 0 ? (
              previewData.map((x, i) => (
                <tr key={i + 1} align="center">
                  {publisher && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handlePublish}
                        src={publishIcon}
                        alt="Publish"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                  <td>{x.name}</td>
                  <td>{x.vishwasthaMandalType}</td>
                  <td style={{ textAlign: "center" }}>{x.fromPeriod}</td>
                  <td style={{ textAlign: "center" }}>{x.toPeriod}</td>
                  <td style={{ textAlign: "center" }}>
                    {x.image &&
                      parse(`<img src=${x.image}  style="width: 60px"/>`)}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <img
                      className="handle"
                      data-params={JSON.stringify(x)}
                      onClick={handleEdit}
                      src={editIcon}
                      alt="Edit"
                      border="0px"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </td>
                  {admin && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeletePreview}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={admin ? 8 : approver ? 7 : 6}
                  style={{ textAlign: "center" }}
                >
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      {liveData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan={admin ? 6 : 5}>
                Live
              </th>
            </tr>
            <tr align="center">
              <td colSpan={admin ? 6 : 5}>
                <span>Vishwastha Mandal Type: </span>
                {vishwasthaMandalTypes && (
                  <select
                    onChange={(e) => {
                      setLiveVishwasthaMandalType(e.target.value);
                      fetchLiveData(e.target.value);
                    }}
                    value={liveVishwasthaMandalType}
                  >
                    {vishwasthaMandalTypes.map((x, i) => (
                      <option key={i} value={x.id}>
                        {x.name}
                      </option>
                    ))}
                  </select>
                )}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr align="center">
              <td>
                <u>Name</u>
              </td>
              <td>
                <u>Vishwastha Mandal Type</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>From Period</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>To Period</u>
              </td>
              <td style={{ textAlign: "center" }}>
                <u>Image</u>
              </td>
              {admin && (
                <td style={{ textAlign: "center" }}>
                  <u>Delete</u>
                </td>
              )}
            </tr>
            {liveData.length > 0 ? (
              liveData.map((x, i) => (
                <tr key={i + 1} align="center">
                  <td>{x.name}</td>
                  <td>{x.vishwasthaMandalType}</td>
                  <td style={{ textAlign: "center" }}>{x.fromPeriod}</td>
                  <td style={{ textAlign: "center" }}>{x.toPeriod}</td>
                  <td style={{ textAlign: "center" }}>
                    {x.image &&
                      parse(`<img src=${x.image}  style="width: 60px"/>`)}
                  </td>
                  {admin && (
                    <td style={{ textAlign: "center" }}>
                      <img
                        className="handle"
                        data-params={x.id}
                        onClick={handleDeleteLive}
                        src={deleteIcon}
                        alt="Delete"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={admin ? 6 : 5} style={{ textAlign: "center" }}>
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </>
  );

  return contents;
}

export default VishwasthaMandal;
